import styles from "./CloseButton.module.css"
import {  CircleX } from 'lucide-react';
/**
* Props for the CloseButton component.
*/ 
interface CloseButtonProps{
    onClick:()=>void, // Click event handler
    className?: string // Optional additional class
}
/**
* A button with X icon.
*
* @param props CloseButton props
* @param {string} props.className - Optional additional class
* @param {() => void} props.onClick - Function to call on click.
* @returns TSX.Element
*/
const CloseButton = ({onClick, className}:CloseButtonProps) => {
    return(
        <>
            <button className={className? `${styles.Close} ${className}` : `${styles.Close}`} onClick={onClick}>
                <CircleX width={34} height={34}/>
            </button>
        </>
    )
};
export default CloseButton;